const isValidOrganizationReportFiscalYear = (fiscalYear) => {
    if (fiscalYear == null) {
        return false;
    }

    const normalized = String(fiscalYear).trim();
    return normalized !== "" && normalized.toUpperCase() !== "N/A";
};

export default isValidOrganizationReportFiscalYear;
